export enum ExternalLogisticianEnum {
  PFS = 'PFS'
}
